/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Form } from '@organisms';

import SponsorSelect from '../SponsorSelect';

const SponsorField = ({ onChange, queryVariables, ...props }) => (
  <Form.Item {...props}>
    <SponsorSelect onChange={onChange} queryVariables={queryVariables} />
  </Form.Item>
);

export default SponsorField;
